import CourseDefaultImg from '../Images/crystal_springs_course.jpeg';

const eventsObj = [
    {
            "name": "Golf Outing",
            "date": { "Month": "September", "Day": "14", 
            "Year": 2026, "Time": "9AM" },
            "Location": "1 Wild Turkey Way, Hamburg, NJ 07419",
            "Description": "Crystal Springs Golf Club",
            "eventOptions": {
                "Golfing": { "Price": "$350", "Includes": [ "Golfing", "BBQ Lunch", "Buffet Dinner", "Open Bar" ]},
                "Dinner": { "Price": "$120", "Includes": [ "Buffet Dinner", "Open Bar" ]}
            },
            "picSrc": CourseDefaultImg,
            "IsOver": false,
            "eventNum": 0,
            "live": true
    }
]

export default eventsObj;